<template>
	<detail :id="id" verify></detail>
</template>

<script>
	import detail from './coupon_task_detail.vue'
	
	export default {
		name: 'coupon_task_verify',
		
		components: {
			detail
		},
		
		props: {
			id: String
		}
	}
</script>